<div  class="card cursor-pointer">
    <h4 class="card-title">
        {{document.approvalDoc ? 'Admin proof of payment: ' : 'Upload proof of payment:'}}
        </h4>

    <div class="card-content">
        <ng-container *ngIf="document.approvalDoc;else setDoc">
            <div class="card-body">
                <div class="upload-wrapper" (click)="viewImage(document.approvalDoc)">
                    <div class="fonticon-wrap"
                    >
                        <i class="ft-file"></i>
                    </div>
                    <span>Proof of payment</span>
                </div>
            </div>
        </ng-container>
        <ng-template #setDoc>
            <div class="card-body">
                <ng-container *ngIf="!selectedFile">
                    <div class="upload-wrapper" (click)="Input.click()">
                        <img src="assets/img/upload-icon.png" />
                        <span>Tap to select files from your phone. We accept PDF, JPG, or PNG files up to 30MB</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="selectedFile">
                    <div class="upload-wrapper">
                        <div class="approval-wrapper" (click)="Input.click()">
                            <span> {{selectedFile.file.name}} </span>
                            <p> {{selectedFile.file.size | fileSize }} </p>
                        </div>
                        <div class="fonticon-wrap" (click)="removeSelectedFile()">
                            <i class="fa fa-trash-o"></i>
                        </div>
                    </div>
                </ng-container>

                <input style="display: none" #Input (change)="selectFile($event)" type="file" accept=".pdf, .jpeg, .png, .jpg" />
            </div>
        </ng-template>

    </div>
</div>
